module.exports = __webpack_public_path__ + "fc4222cfb9fd51e75ca87d35d058d0df.png";